import { registerBlock } from "../../registry";
import { makeId } from "../../helpers";
import type { ContentBlock } from "../../types";

const ovarianStimulation: ContentBlock<"module"> = {
  id: makeId("module-ovarian-stimulation"),
  kind: "module",
  tags: ["her", "treatment", "during-cycle", "medications"],
  title: "Ovarian Stimulation",
  subtitle: "10–14 days of controlled stimulation with monitoring",
  icon: "💉",
  body: {
    duration: "10–14 days",
    category: "treatment",
    forWhom: "her",
    includes: [
      "Daily injectable medication protocol (FSH/LH)",
      "Monitoring ultrasounds every 2–3 days",
      "Estradiol blood draws to track follicle growth",
      "Injection coaching with video tutorials",
      "Dose adjustment guidance based on response",
      "Trigger shot timing coordination",
    ],
    trackableMarkers: [
      {
        name: "Follicle count (growing)",
        expectedToChange: true,
        expectation:
          "Follicles grow ~1–2mm/day during stimulation. Monitoring tracks how many are maturing and at what size.",
      },
      {
        name: "Estradiol (E2)",
        expectedToChange: true,
        expectation:
          "Rising E2 confirms follicles are responding. Each mature follicle contributes ~200–300 pg/mL.",
      },
    ],
    priceRange: { low: 3000, high: 6000 },
    currency: "USD",
    status: "coming-soon",
    steps: [
      {
        title: "Start injections",
        description:
          "Begin daily gonadotropin injections. First monitoring appointment in 4–5 days.",
      },
      {
        title: "Monitoring",
        description:
          "Ultrasound + blood draw every 2–3 days. Doses adjusted based on follicle growth and E2 levels.",
      },
      {
        title: "Trigger shot",
        description:
          "When lead follicles reach 18–20mm, a trigger shot is administered. Retrieval scheduled 36 hours later.",
      },
    ],
  },
  sources: [
    {
      title: "Ovarian stimulation for IVF/ICSI",
      journal: "Human Reproduction Update",
      year: 2020,
      evidenceLevel: "meta-analysis",
    },
  ],
};

registerBlock(ovarianStimulation);
